/** guid prefix of the userspace doc holding one template's content */
export const ACCOUNT_TEMPLATE_DOC_PREFIX = 'account-template:';

export const accountTemplateDocId = (templateId: string) =>
  `${ACCOUNT_TEMPLATE_DOC_PREFIX}${templateId}`;

/**
 * Userspace has no blob channel of its own, so assets are inlined into the
 * template doc. These caps keep a single yjs update reasonable.
 */
export const MAX_ACCOUNT_TEMPLATE_BLOB_SIZE = 2 * 1024 * 1024;
export const MAX_ACCOUNT_TEMPLATE_TOTAL_SIZE = 5 * 1024 * 1024;
export const MAX_ACCOUNT_TEMPLATES = 100;

export const ACCOUNT_TEMPLATE_CONTENT_VERSION = 1;
